import { FLIGHTDETAILS } from "src/common/constants";
import {
  FlightDetailsAction,
  UpcomingFlightI,
} from "../reducers/flightDetails";
export const FLIGHTDETAILS_FETCH_DATA = `${FLIGHTDETAILS}_GET_DATA` as const;
export const FLIGHTDETAILS_FETCH_INVOKED =
  `${FLIGHTDETAILS}_GET_INVOKED` as const;
export const FLIGHTDETAILS_FETCH_SUCCESS =
  `${FLIGHTDETAILS}_GET_SUCCESS` as const;
export const FLIGHTDETAILS_FETCH_FAILED =
  `${FLIGHTDETAILS}_GET_FAILED` as const;

export const fetchFlightDetails = (
  timeFrames: { previous: number; upcoming: number },
  id: string
): {
  type: typeof FLIGHTDETAILS_FETCH_DATA;
  id: string;
  timeFrames: { previous: number; upcoming: number };
} => ({
  type: FLIGHTDETAILS_FETCH_DATA,
  timeFrames,
  id,
});
export const fetchFlightDetailsInvoked = (id: string): FlightDetailsAction => ({
  type: FLIGHTDETAILS_FETCH_INVOKED,
  id,
});
export const fetchFlightDetailsSuccess = (
  payload: UpcomingFlightI[],
  id: string
): FlightDetailsAction => ({
  type: FLIGHTDETAILS_FETCH_SUCCESS,
  payload,
  id,
});
export const fetchFlightDetailsFailed = (
  error: Error,
  id: string
): FlightDetailsAction => ({
  type: FLIGHTDETAILS_FETCH_FAILED,
  error,
  id,
});
